import { Ref, ref } from '@vue/composition-api';
import async from 'async';
import teamHandler from '@/renderer/views/desktop/ManageConsole/TeamManagement/compositions/teamHandler';
import { SMH } from '@/renderer/scripts/smh';
type Handler = {
  findTeamIdByPath: (
    defaultTeamPath: string[],
    root: SMH.TeamTreeNode,
  ) => Promise<{
    level: Ref<number>;
    defaultId: number;
    defaultTeam: SMH.TeamTreeNode;
    teamData: SMH.TeamTreeNode;
    parentIds: number[];
  }>;
};
type Params = {
  checkPermission: 0 | 1;
  needCheckManagementPermission: boolean;
  withPath: boolean;
};
export default function handler({
  checkPermission = 0,
  needCheckManagementPermission = false,
  withPath = false,
}: Params): Handler {
  const { listTeam } = teamHandler(checkPermission, needCheckManagementPermission);
  const methods = {
    /**
     * 根据给出的路径找到对应团队的 teamId 并展开对应的团队
     */
    async findTeamIdByPath(defaultTeamPath: string[], root: SMH.TeamTreeNode) {
      const rootNode: SMH.TeamTreeNode = root;
      let currTeam: SMH.TeamTreeNode = rootNode;
      let defaultId = -1;
      const tempPaths = [...defaultTeamPath].splice(1);
      const expandLevel = ref(1);
      const parentIds = [currTeam.id];
      const findNodeByPath = (path: string, children: SMH.TeamTreeNode[]) => {
        let findNode: SMH.TeamTreeNode | undefined;
        for (let index = 0; index < children.length; index++) {
          const child = children[index];
          if (child.name === path) {
            findNode = child;
          }
        }
        return findNode;
      };
      if (defaultTeamPath.length > 0 && defaultTeamPath[0] === currTeam.name) {
        // 遍历获取
        try {
          await async.eachLimit(tempPaths, 1, (path, next) => {
            if (typeof currTeam.children === 'boolean') {
              listTeam({ teamId: currTeam.id, withPath }).then(res => {
                currTeam.children = (res.children || []).map(item => ({
                  ...item,
                  children: item.children && item.children.length > 0,
                })) as any;
                const node = findNodeByPath(path, currTeam.children || []);
                if (node) {
                  currTeam = node;
                  defaultId = node.id;
                  expandLevel.value++;
                  parentIds.push(node.id);
                  next();
                } else {
                  next(new Error('NotFound'));
                }
              });
            } else if (currTeam.children) {
              const node = findNodeByPath(path, currTeam.children);
              if (node) {
                if (currTeam.name !== defaultTeamPath[0]) {
                  expandLevel.value++;
                }
                currTeam = node;
                defaultId = node.id;
                parentIds.push(node.id);
                next();
              } else {
                next(new Error('NotFound'));
              }
            }
          });
        } catch (error) {
          // 查找失败则回退到根目录
          defaultId = -1;
        }
      }
      return {
        level: expandLevel,
        defaultId,
        defaultTeam: currTeam,
        parentIds,
        teamData: rootNode,
      };
    },
  };
  return {
    ...methods,
  };
}
